if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
    setTimeout(() => {
        const observer = new MutationObserver((MutationList) => {
            for (let item of MutationList) {
                if (item.target.classList.contains('cart_total_price')) {
                   BSS_B2B.observer.cartSubject.listenCartCheckout();
                   handleTEBox();
                }
            }
        })
        observer.observe(document.body, {
            childList: true,
            subtree: true
        })
    }, 300)
}

const pageType =
  window.ShopifyAnalytics &&
  window.ShopifyAnalytics.meta &&
  window.ShopifyAnalytics.meta.page &&
  window.ShopifyAnalytics.meta.page.pageType;

if (pageType !== "cart") {
  let counter = 0;
  const interval = setInterval(() => {
    const footerPrice = document.querySelector(".cart-drawer-container .cart-subtotal");
   
    if (footerPrice){
      handleTEBox();
      clearInterval(interval);
    } else {
      counter += 100;
      if (counter >= 10000) {
        clearInterval(interval);
      }
    }
  }, 100);
} else {
  let counter = 0;
  const interval = setInterval(() => {
    const vatInputWrapper = document.querySelector(".bss-b2b-vat-input-wrapper");

    if (vatInputWrapper) {
      handleTEBox();
      clearInterval(interval);
    } else {
      counter += 100;
      if (counter >= 10000) {
        clearInterval(interval);
      }
    }
  }, 100);
}

function handleTEBox() {
  const translations = BSS_B2B.te.teTranslations;
  const headerText = document.querySelector(
    ".bss-b2b-translation-vat-form_header_text"
  );
  if (headerText) {
    headerText.innerText = translations.form_header_text;
  }

  const subtitleText = document.querySelector(
    ".bss-b2b-translation-vat-form_subtitle_text"
  );
  if (subtitleText) {
    subtitleText.innerText = translations.form_subtitle_text;
  }

  const successMessages = [
    document.querySelector(".bss-b2b-translation-vat-form_success_message"),
    document.querySelector(".bss-b2b-translation-vat-form_success_message_uk"),
    document.querySelector(".bss-b2b-translation-vat-form_success_message_abn"),
    document.querySelector(".bss-b2b-translation-vat-form_success_message_gst"),
    document.querySelector(
      ".bss-b2b-translation-vat-form_success_message_us_ein"
    ),
  ];

  successMessages.forEach((msg, index) => {
    if (msg) {
      switch (index) {
        case 0:
          msg.innerText = translations.form_success_message || "";
          break;
        case 1:
          msg.innerText = translations.form_success_message_uk || "";
          break;
        case 2:
          msg.innerText = translations.form_success_message_abn || "";
          break;
        case 3:
          msg.innerText = translations.form_success_message_gst || "";
          break;
        case 4:
          msg.innerText = translations.form_success_message_us_ein || "";
          break;
      }
    }
  });

  const errorMessages = [
    document.querySelector(".bss-b2b-translation-vat-form_error_message"),
    document.querySelector(".bss-b2b-translation-vat-form_error_message_uk"),
    document.querySelector(".bss-b2b-translation-vat-form_error_message_abn"),
    document.querySelector(".bss-b2b-translation-vat-form_error_message_gst"),
    document.querySelector(
      ".bss-b2b-translation-vat-form_error_message_us_ein"
    ),
    document.querySelector(
      ".bss-b2b-translation-vat-form_validate_country_code_message"
    ),
  ];

  errorMessages.forEach((msg, index) => {
    if (msg) {
      switch (index) {
        case 0:
          msg.innerText = translations.form_error_message || "";
          break;
        case 1:
          msg.innerText = translations.form_error_message_uk || "";
          break;
        case 2:
          msg.innerText = translations.form_error_message_abn || "";
          break;
        case 3:
          msg.innerText = translations.form_error_message_gst || "";
          break;
        case 4:
          msg.innerText = translations.form_error_message_us_ein || "";
          break;
        case 5:
          msg.innerText = translations.form_validate_country_code_message || "";
          break;
      }
    }
  });
}

const config = {
  selectorCard: '#qikify-stickycart-v2-app .qsc2-product-item-wrapper',
  selectorOriginPrice: ``,
  selectorFinalLinePrice: `.text-right.whitespace-nowrap:has([part="money"])`,
  selectorSubtotalPrice: '.easc-miniCartProductsDiv .eascCartSubtotal .prodRowPrice', 
};

////
function replacePrice() {
    let price = document.querySelectorAll('[bss-b2b-cart-item-key][bss-b2b-final-line-price')
    let host = document.querySelector('#recharge-storefront-experiences__cart-drawer')
    const shadow = host.shadowRoot;
    const cartItems = shadow.querySelectorAll(`.border-storefront-drawer-border[role ='listitem']`);
    if (price.length) {
        price.forEach((e) => {
            let key = e.getAttribute('bss-b2b-cart-item-key')
            if (key) {
                let cartitem = BSS_B2B.storage.cartStorage.get(key)
                let subtotal
                if (cartitem && cartitem.bssB2BPriceAfterPL) {
                    subtotalPrice = cartitem.bssB2BPriceAfterPL * cartitem.quantity
                }
                let a = shadow.querySelector(`[bss-b2b-cart-item-key='${key}']`)
                let newPrice = document.createElement('span')
                if (a) {
                    a.innerHTML =  `<span style="text-decoration: line-through; margin-right: 10px; color: #000000;"> ${BSS_B2B.formatMoney(cartitem.final_line_price)}</span>` + `<span style="color: #000000;">${BSS_B2B.formatMoney(subtotalPrice)}</span>` 
                    // a.after(newPrice)
                    // a.style.display = 'none'
                  }
            }
        })
    }

    const total = shadow.querySelector('[bss-b2b-cart-total-price]')
    if (total && BSS_B2B?.shopData.cart.bss_b2b_total_price) {
      total.innerHTML = BSS_B2B.formatMoney(BSS_B2B.shopData.cart.bss_b2b_total_price)
    }
    let buttonCheckout =  shadow.querySelector(`footer .px-drawer`);
    if (buttonCheckout  ) {
      if(!shadow.querySelector(`.bss-checkout-button`)){
      buttonCheckout.after(document.querySelector('.bss-checkout-button '))
      setTimeout(() => {
        shadow.querySelector('.bss-checkout-button').style.pointerEvents = "auto";
      }, 500);
      shadow.querySelector('.bss-checkout-button').addEventListener('click', (e)=>{
         e.preventDefault();
        e.target.innerHTML = 'loading'
        e.target.style.pointerEvents = 'none'
        e.target.style.opacity = '0.6'
      })
      }
    }
    
}


/////

async function addCartPriceAttributes(config) {
    const AjaxCartApi = window.BSS_B2B?.utils?.AjaxCartApi;
    if (!AjaxCartApi) return;

    let lineItems = [];
    try {
        const res = await AjaxCartApi.getCart();
        lineItems = res.items || [];
    } catch (err) {
        window.BSS_B2B?.logger?.error?.('[BSS B2B] Failed to fetch cart.js:', err);
        return;

    }

    let host = document.querySelector('#recharge-storefront-experiences__cart-drawer')
    const shadow = host.shadowRoot;

    const cartItems = shadow.querySelectorAll(`.border-storefront-drawer-border[role ='listitem']`);

    const priceRecommended = shadow.querySelector('.flex.flex-col.gap-21')
    let appBlock = document.querySelector('.shopify-block.shopify-app-block:has(#recharge-storefront-experiences__cart-drawer')
    if (priceRecommended) {
        setTimeout(() => {
            priceRecommended.style.display = 'none'
        }, 500);

    }
    cartItems.forEach((item) => {
        const link = item.querySelector('.rounded-storefront-drawer');
        const title = link?.getAttribute('src');
        if (!title || item.hasAttribute('bss-b2b-cart-item-key')) return;
        const finalEls = config.selectorFinalLinePrice ?
            Array.from(item.querySelectorAll(config.selectorFinalLinePrice)) :
            [];

        const productMatch = lineItems.find((p) => {
            return p.image.toString().includes(title)
        });
        const itemKey = productMatch?.key;

        // if (itemKey) item.setAttribute('bss-b2b-cart-item-key', itemKey);

        finalEls.forEach((el) => {
            el.setAttribute('bss-b2b-final-line-price', '');
            let newPrice = document.createElement('span')

            if (itemKey) {
                el.setAttribute('bss-b2b-cart-item-key', itemKey);
                newPrice.setAttribute('bss-b2b-cart-item-key', itemKey);
                newPrice.setAttribute('bss-b2b-final-line-price', '');
                appBlock.after(newPrice)
            }

        });
    });

    const totalPrice = shadow.querySelector('footer .flex.gap-2.font-semibold');
    if (totalPrice && !totalPrice.hasAttribute('bss-b2b-cart-total-price')) {
        let newPrice = document.createElement('span')
        newPrice.setAttribute('bss-b2b-cart-total-price', '');
        totalPrice.setAttribute('bss-b2b-cart-total-price', '');

    }
    let buttonCheckout = shadow.querySelector(`button[type="submit"]`);
    
    if (buttonCheckout, totalPrice) {
        let newCheckout = document.createElement('button');
        newCheckout.classList.add('bss-checkout-button', 'checkout-btn');
        newCheckout.textContent = 'Checkout';
        buttonCheckout.style.display = 'none';
        newCheckout.classList.add(
            "cursor-pointer",
            "inline-flex",
            "items-center",
            "justify-center",
            "gap-2",
            "whitespace-nowrap",
            "text-base",
            "transition-[color,box-shadow,background-color]",
            "disabled:pointer-events-none",
            "disabled:opacity-50",
            "[&_svg]:pointer-events-none",
            "[&_svg:not([class*='size-'])]:size-4",
            "[&_svg]:shrink-0",
            "outline-ring/50",
            "focus-visible:ring-offset-2",
            "aria-invalid:focus-visible:ring-0",
            "aria-disabled:pointer-events-none",
            "aria-disabled:opacity-50",
            "bg-storefront-drawer-primary",
            "text-storefront-drawer-primary-foreground",
            "hover:bg-storefront-drawer-primary/80",
            "rounded-storefront-drawer-button",
            "font-semibold",
            "ring-storefront-drawer-primary/80",
            "focus-visible:ring-2",
            "focus-visible:outline-none",
            "h-10",
            "px-4",
            "py-2",
            "has-[>svg]:px-3",
            "w-full", 
            "checkout-btn"
        );
        appBlock.after(newCheckout)
    }
}


function observeMiniCartRepeatedly() {
    let host = document.querySelector('#recharge-storefront-experiences__cart-drawer')
    const shadow = host.shadowRoot;
    const targetSelector = '.bg-storefront-drawer-background:has(.border-storefront-drawer-border)';
    const mainObserver = new MutationObserver(() => {
        const miniCart = shadow.querySelector(targetSelector);
        if (miniCart && !miniCart.dataset.bssB2bProcessed) {
            console.log('[MiniCart] Mini cart mới xuất hiện.');
            miniCart.dataset.bssB2bProcessed = 'true';
            addCartPriceAttributes(config).then(() => {
                window.BSS_B2B?.observer?.cartSubject?.notifyObserver('CartUpdate', 'CartMutate');
                BSS_B2B.observer.cartSubject.listenCartCheckout()

                let host = document.querySelector('#recharge-storefront-experiences__cart-drawer')
                const shadow = host.shadowRoot;
                const cartContainer = shadow.querySelector(`#cart-drawer section[role='list']`);
                setTimeout(()=>{
                  replacePrice()
                   const priceRecommended = shadow.querySelector(`.px-drawer.flex.flex-col.gap-2`)
                console.log(priceRecommended)
                if (priceRecommended) {
                    priceRecommended.style.display = 'none'
                }
                }, 500)
               
                  let input = shadow.querySelectorAll(`input[data-slot='input']`);
                 
                  input.forEach((e) => {
                      e.addEventListener('change', () => {
                        setTimeout(() => {
                          addCartPriceAttributes(config);
                          window.BSS_B2B?.observer?.cartSubject?.notifyObserver('CartUpdate', 'CartMutate');
                          }, 3000)
                          

                          setTimeout(() => {
                              replacePrice()
                          }, 3500)
                      })
                  })

                   let buttonChangeQuantity = shadow.querySelectorAll(`button[data-slot='button']`);
                  
                  buttonChangeQuantity.forEach((e) => {
                      e.addEventListener('click', () => {
                       
                          setTimeout(() => {
                          addCartPriceAttributes(config);
                          window.BSS_B2B?.observer?.cartSubject?.notifyObserver('CartUpdate', 'CartMutate');
                          }, 3000)

                          setTimeout(() => {
                              replacePrice()
                          }, 3500)
                      })
                  })

            });
        }
    });

    mainObserver.observe(document.body, {
        childList: true,
        subtree: true,
    });
}

document.addEventListener('DOMContentLoaded', observeMiniCartRepeatedly);


